import React from 'react';
import { Icon } from 'fronton-react';
import { MobileAppLogo, MobileAppLogoLegacy } from 'components/icons';
import { logoWrap } from './styles';

export type LogoProps = {
  isNewTheme?: boolean;
};

export const Logo: React.FC<LogoProps> = ({ isNewTheme }) => (
  <Icon className={logoWrap} data-qa-header-mobile-app-logo="">
    {isNewTheme ? <MobileAppLogo /> : <MobileAppLogoLegacy />}
  </Icon>
);
